import React from 'react';
import CopyableExpandableFormGroup from './CopyableExpandableFormGroup';

/**
 * @param {Object} props
 * @param {string} props.value
 */
export default function AmountFormGroup({ label, value }) {
  return <CopyableExpandableFormGroup label={label} value={value} />;
}

AmountFormGroup.defaultProps = {
  label: 'Amount',
};
